import { render } from "./HeaderComponent.vue?vue&type=template&id=8268e946&scoped=true&ts=true"
import script from "./HeaderComponent.vue?vue&type=script&lang=ts"
export * from "./HeaderComponent.vue?vue&type=script&lang=ts"

import "./HeaderComponent.vue?vue&type=style&index=0&id=8268e946&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8268e946"]])

export default __exports__